const { TIPO_APOLICE } = require('./tipo_apolice');

export const STAR_PRODUCT_CODE = {
  [TIPO_APOLICE.AUTO]: '210',
  [TIPO_APOLICE.RCVAT]: '011',
  [TIPO_APOLICE.VIDA]: '012',
  [TIPO_APOLICE.MICRO_VIDA]: '006',
};
